import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';

import favicon from '@mds/shared/assets/favicon.svg';
import { shouldRetryRequest } from '@mds/shared/lib/api';

import { SessionProvider } from './auth/session';
import App from './App';

import './index.css';

// Imported rather than linked from index.html: Vite does not rewrite a path
// out of the app's own folder there, and both apps share the one file.
document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', favicon);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryRequest,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
